<template style="z-index: 100;">

  <!-- loading state -->
  <v-layout column v-if="this.widgetData.loading">
    <app-google-translator/>
    <the-title type="pcw"/>
    <div class="text-xs-center">
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
  </v-layout>
  <!-- Empty Policy -->
  <v-layout column v-else-if="emptyPolicy && !this.widgetData.loading">
    <app-google-translator/>
    <the-title type="pcw"/>
    <div class="noPolicy text-xs-center mt-2">
      Sorry, protection is not available in your location at this time.
    </div>
  </v-layout>
  <v-layout column v-else>
    <v-flex>
      <app-google-translator/>
      <the-title type="pcw"/>
      <the-description type="pcw" class="openEndedDescription"/>
      <the-perils type="pcw"/>
    </v-flex>
    <v-flex>
      <the-customer
        title="Customer Information"
        info="Enter your full name and email address. All are fields required."
        :first-name.sync="firstName"
        :last-name.sync="lastName"
        :email.sync="email"
        :customer-completed.sync="customerCompleted"
      />
    </v-flex>
    <v-flex>
      <the-address
        type="pcw"
        :country.sync="country"
        :state.sync="state"
        :address.sync="address"
        :city.sync="city"
        :zipCode.sync="zipCode"
        :is-billing-address-complete.sync="isAddressValid"/>
    </v-flex>
    <v-flex mb-4>
      <v-divider class="divider"/>
    </v-flex>
    <v-flex>
      <text-block
        title="Ticket Information"
        subtitle="Add your tickets"
        :text="ticketInformationText"
      />
      <v-layout bg-gray class="eventWrapper" mx-3 mb-2 column wrap>
        <v-flex>
          <the-event
            :eventName.sync="eventName"
            :eventDate.sync="eventDate"
            :eventVenue.sync="eventVenue"
            :eventCity.sync="eventCity"
            :eventCountry.sync="eventCountry"
            :eventState.sync="eventState"
          />
          <v-flex>
            <the-ticket
              v-for="(ticket) in tickets"
              :key="ticket.id"
              :eventName="eventName"
              :eventDate="eventDate"
              :eventVenue="eventVenue"
              :eventCity="eventCity"
              :eventCountry="eventCountry"
              :eventState="eventState"
              :country="country"
              :region="state"
              :apiKey="apiKey"
              :currency="currency"
              :event-and-tickets-complete.sync="eventAndTicketsComplete"
              :is-address-valid="isAddressValid"
              :customer-completed="customerCompleted"
              :id="ticket.id"
              :remove-ticket="removeTicket"
            />
          </v-flex>
        </v-flex>
        <v-flex justify-end>
          <v-btn
            @click.native="addTicket"
            class="addButton white--text"
          >
            <v-icon class="addIcon">add_circle_outline</v-icon>
            Add Another Ticket
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex my-4>
      <v-divider class="divider"/>
    </v-flex>
    <v-flex>
      <text-block
        title="Ticket Summary"
      />
      <the-table
        type="pcw"
        :quotedTickets="quotedTickets"
      />
      <v-divider v-if="quotedTickets.length" class="tableDivider"/>
      <v-flex v-if="quotedTickets.length" mx-3 pt-2>
        <span class="totalCostWrapper">
          Your Protection Quote Total:
          <span class="totalCostText">{{ totalCost }}</span>
        </span>
      </v-flex>
    </v-flex>
    <v-flex pt-4 mt-4>
      <v-btn
        @click.native="routeToCard"
        data-testid="billing-information"
        class="billingInfoButton white--text"
        :disabled="!allowCustomerToProceed"
      >
        Billing Information
        <v-icon class="nextIcon" right>arrow_forward_ios</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TextBlock from 'components/TextBlock.vue';
import TheTitle from 'components/TheTitle.vue';
import TheDescription from 'components/TheDescription.vue';
import ThePerils from 'components/ThePerils.vue';
import TheCustomer from 'components/TheCustomer.vue';
import TheAddress from 'components/TheAddress.vue';
import TheEvent from 'components/TheEvent.vue';
import TheTable from 'components/TheTable.vue';
import TheTicket from 'components/TheTicket.vue';
import AppGoogleTranslator from 'components/AppGoogleTranslator.vue';
import urlUtils from 'utils/url';
import { getProductSlug } from 'utils/product';

export default {
  name: 'Purchase',
  components: {
    TextBlock,
    TheTitle,
    TheDescription,
    ThePerils,
    TheCustomer,
    TheAddress,
    TheEvent,
    TheTicket,
    TheTable,
    AppGoogleTranslator,
  },
  data: () => ({
    isAddressValid: false,
    firstName: '',
    lastName: '',
    email: '',
    country: '',
    state: '',
    zipCode: '',
    address: '',
    city: '',
    eventName: '',
    eventDate: '',
    eventVenue: '',
    eventCity: '',
    eventCountry: '',
    eventState: '',
    ticketDescription: '',
    ticketCost: '',
    quantity: '',
    totalProtectionCost: '',
    eventAndTicketsComplete: false,
    currency: 'USD',
    apiKey: '',
    ticketInformationText: 'Please fill in the event and ticket information with the EXACT cost of each ticket. Your refund protection will be capped at the ticket price you report here even if the actual ticket price exceeds this reported amount. You may add multiple tickets for the event by clicking "Add Another Ticket". All fields are required.',
    pcw_token: '',
    customerCompleted: false,
    totalCost: 0,
    orderCreated: '',
    validateForm: false,
    tickets: [],
    quotedTickets: [],
    count: 0,
    addressValidCount: 0,
    client: '',
  }),
  mounted() {
    if (this.userInformation.firstName && this.userInformation.lastName) {
      this.firstName = this.userInformation.firstName;
      this.lastName = this.userInformation.lastName;
      this.email = this.userInformation.email;
      this.country = this.userInformation.country;
      this.state = this.userInformation.state;
      this.zipCode = this.userInformation.zipCode;
      this.address = this.userInformation.address;
      this.city = this.userInformation.city;
      this.eventName = this.userInformation.eventName;
      this.eventDate = this.userInformation.eventDate;
      this.eventVenue = this.userInformation.eventVenue;
      this.eventCity = this.userInformation.eventCity;
      this.eventCountry = this.userInformation.eventCountry;
      this.eventState = this.userInformation.eventState;
    }

    this.pcw_token = urlUtils.getTokenFromURL();
    this.client = urlUtils.getClientSlugFromDomain();

    this.validatePCWToken({ client: this.client, token: this.pcw_token }).catch(() => {
      this.$router.push({ name: 'error' });
    });

    if (this.globalQuotedTickets) {
      this.removeAllGlobalQuotedTickets();
    }

    this.tickets.push({ id: this.count++ }); // eslint-disable-line
  },
  computed: {
    ...mapGetters('widgetData', ['widgetData']),
    ...mapGetters('ipStatus', ['ipStatus']),
    ...mapGetters('quote', [
      'globalQuotedTickets',
      'globalQuotedTicketsUpdateCount',
      'userInformation',
      'openEndedTokenCurrencySymbol',
      'openEndedTokenIsExpired',
      'openEndedTokenCurrency',
      'openEndedTokenClient',
    ]),
    allowCustomerToProceed() {
      let value = false;
      if (
        this.totalCost !== 0
        && this.isAddressValid
        && this.customerCompleted
        && this.eventAndTicketsComplete
        && this.tickets.length
      ) {
        value = true;
      }
      return value;
    },
    emptyPolicy() {
      if (this.widgetData && (!this.widgetData.perils || this.widgetData.perils.length === 0)) {
        return true;
      }
      return false;
    },
  },
  watch: {
    ipStatus(data) {
      if (data) {
        this.fetchICWWidgetData({
          client: this.client,
          params: {
            product: getProductSlug(urlUtils.getProductFromDomain()),
            country: this.ipStatus.country_code,
            region: this.ipStatus.region_code,
          },
        }).catch(() => {
          this.$router.push({ name: 'error' });
        });
      }
    },
    globalQuotedTicketsUpdateCount(value) {
      if (value) {
        this.quotedTickets = this.createdFormattedTickets();
        this.createTotalCost(this.quotedTickets);
      } else {
        this.quotedTickets = [];
      }
    },
    isAddressValid(value) {
      if (value) {
        this.addressValidCount = this.addressValidCount + 1;
      } else if (!value && this.addressValidCount > 0) {
        this.resetTicketState();
      }
    },
    country(value) {
      if (this.addressValidCount > 0 && !this.isAddressValid && value) {
        this.resetTicketState();
      }
    },
    zipCode(value) {
      if (this.addressValidCount > 0 && !this.isAddressValid && value) {
        this.resetTicketState();
      }
    },
    state(value) {
      if (this.addressValidCount > 0 && !this.isAddressValid && value) {
        this.resetTicketState();
      }
    },
    city(value) {
      if (this.addressValidCount > 0 && !this.isAddressValid && value) {
        this.resetTicketState();
      }
    },
    address(value) {
      if (this.addressValidCount > 0 && !this.isAddressValid && value) {
        this.resetTicketState();
      }
    },
  },
  methods: {
    ...mapActions('widgetData', ['fetchICWWidgetData']),
    ...mapActions(['pushMessageAlert']),
    ...mapActions('quote', ['removeGlobalQuotedTickets', 'saveUserInformation', 'removeAllGlobalQuotedTickets', 'getOpenEndedToken', 'validatePCWToken']),
    addTicket() {
      this.tickets.push({ id: this.count++ }); // eslint-disable-line
    },
    removeTicket(id) {
      const index = this.tickets.findIndex(f => f.id === id);
      this.tickets.splice(index, 1);
      this.removeGlobalQuotedTickets({
        id,
        globalQuotedTickets: this.globalQuotedTickets,
      });

      if (!this.tickets.length) {
        this.removeAllGlobalQuotedTickets();
      }
    },
    resetTicketState() {
      if (this.quotedTickets.length) {
        this.removeAllGlobalQuotedTickets();
        this.tickets.length = 0;
        this.quotedTickets = [];
      }
    },
    createdFormattedTickets() {
      const tickets = [];
      const modifiedGlobalQuotedTickets = Object.entries(this.globalQuotedTickets);
      for (let i = 0; i < modifiedGlobalQuotedTickets.length; i++) { // eslint-disable-line
        tickets.push(modifiedGlobalQuotedTickets[i][1]);
      }

      return tickets.flat();
    },
    createTotalCost(tickets) {
      this.totalCost = 0;
      if (tickets.length) {
        for (let i = 0; i < tickets.length; i++) { // eslint-disable-line
          this.totalCost = this.totalCost + (
            Number(tickets[i].ticketProtectionCost) * Number(tickets[i].quantity)
          );
        }
        this.totalCost = `${tickets[0].currency} ${this.totalCost.toFixed(2)}`;
      }
    },
    routeToCard() {
      const body = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        country: this.country,
        state: this.state,
        zipCode: this.zipCode,
        address: this.address,
        city: this.city,
        eventName: this.eventName,
        eventDate: this.eventDate,
        eventVenue: this.eventVenue,
        eventCity: this.eventCity,
        eventCountry: this.eventCountry,
        eventState: this.eventState,
        apiKey: this.apiKey,
        pcw_token: this.pcw_token,
      };

      if (
        this.totalCost !== 0
        && this.isAddressValid
        && this.customerCompleted
        && this.eventAndTicketsComplete
      ) {
        this.saveUserInformation(body)
          .then(() => {
            this.$router.push({ name: 'billing' });
          });
      }
    },
  },
};
</script>

<style scoped>
.noPolicy {
  font-family: Gotham;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
}
.underTableText {
  font-size: 16px;
  font-family: Gotham;
  text-align: right;
  color: #333333;
  padding-top: 5px;
  position: relative;
  right: 26px;
}

.openEndedDescription {
  padding-bottom: 0px !important;
}

.totalCoverageText {
  font-weight: bold;
}

.bg-gray {
  background-color: #f2f2f2;
}

.eventWrapper {
  border-radius: 12px;
}

.addButton {
  width: 253.25px;
  height: 60px;
  border-radius: 5px;
  background-color: #0eb908 !important;
  float: right;
  margin: 0px 24px 24px 24px !important;
}

.billingInfoButton {
  width: 332px;
  height: 61px;
  border-radius: 5px;
  background-color: #31b0e5 !important;
  float: right;
  border-radius: 5px;
  position: relative;
  right: 10px;
}

.totalCostWrapper {
  font-family: Gotham;
  font-size: 20px;
  float: right;
  position: relative;
  right: 10px;
}

.totalCostText {
  font-weight: bold;
}

.tableDivider {
  border-width: 1.5px;
  max-width: 96%;
  margin: 0 auto;
}

.nextIcon {
  margin: 0px;
  position: relative;
  left: 50px;
  font-size: 16px;
}

.addIcon {
  position: relative;
  right: 20px;
}

/* Tablet Break Point */
@media screen and (max-width: 1264px) {
  .addIcon {
    width: auto;
    right: 10px;
  }
}

/* Mid Phone to Tablet Break Point */
@media screen and (min-width: 767px) and (max-width: 959px) {
  .underTableText {
    right: 18px;
  }

  .addIcon {
    width: auto;
    right: 10px;
  }
}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .underTableText {
    position: static;
    padding-right: 20px;
  }

  .billingInfoButton {
    width: 265px;
    font-size: 14px;
  }

  .addButton {
    width: 219.25px;
    font-size: 14px
  }

  .nextIcon {
    left: 30px;
  }

  .addIcon {
    width: auto;
    right: 10px;
  }
}

/* Mobile Break Point Medium */
@media screen and (min-width: 375px) and (max-width: 375px) {
  .billingInfoButton {
    width: 319px;
  }

  .addButton {
    width: 278px;
  }
}

/* Mobile Break Point Larger */
@media screen and (min-width: 376px) and (max-width: 767px) {
  .billingInfoButton {
    width: 360px;
  }

  .addButton {
    width: 311px;
  }
}
</style>
